import React, { Suspense, useEffect } from "react";
import ReactDOM from "react-dom/client";
import WebApp from "./containers/App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "redux/store"; // Assuming the modified store.js file is in the 'redux' directory
import "./multilingual/index";
import FallBackLoader from "./components/loader/FallbackLoader";
import { BrowserRouter } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "components/dialogs/ErrorFallback";
import { SocketProvider } from "hooks/socketContext";
import { WebRTCProvider } from "hooks/webrtcContext";
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import { isMobileDevice } from "components/Devices/detectDevices";
import MobileApp from "mobile/MobileApp";
import { datadogRum } from '@datadog/browser-rum';
import axios from "axios";

const root = ReactDOM.createRoot(document.getElementById("root"));

const logError = (error, info) => {
  console.log(error, info);
};
// test commit

let logLevelDisable = {
  log: [0, 2, 4, 6],
  warn: [0, 1, 4, 5],
  error: [0, 1, 2, 3],
};

const disableAllLogs = () => {
  console.log = () => { };
  console.warn = () => { };
  console.error = () => { };
  console.assert = () => { };
};

const initApp = async () => {
  try {
    const response = await axios.get('/version.json');
    const appVersion = response?.data?.version;

    datadogRum.init({
      applicationId: process.env.REACT_APP_DD_RUM_APPLICATION_ID,
      clientToken: process.env.REACT_APP_DD_RUM_CLIENT_TOKEN,
      site: 'us5.datadoghq.com',
      service: 'noki.ai',
      version: appVersion,
      env: process.env.NODE_ENV || 'production',
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      defaultPrivacyLevel: 'mask',
      trackResources: true,
      trackLongTasks: true,
      trackUserInteractions: true,
      enablePrivacyForActionName: true,
    });

  } catch (error) {
    console.error("Error initializing app with version:", error);
  }
};

initApp();

datadogRum.startSessionReplayRecording();

if (!localStorage.getItem("logs")) {
  disableAllLogs();
} else {
  let logLevel = Number(localStorage.getItem("logs"));
  if (!isNaN(logLevel)) {
    Object.keys(logLevelDisable).forEach((n) => {
      if (logLevelDisable[n].includes(logLevel)) {
        console[n] = () => { };
      }
    });
  } else {
    disableAllLogs();
  }
}

const isMobile = isMobileDevice()

const setDatadogUser = (username, userEmail, tenantID) => {
  datadogRum.setUser({
    id: tenantID,
    name: username,
    email: userEmail
  });
}

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <Suspense fallback={<FallBackLoader loaderMessage={true} />}>
            <ErrorBoundary FallbackComponent={ErrorFallback} onError={logError}>
              <SocketProvider>
                <WebRTCProvider>
                  {isMobile ? <MobileApp setDatadogUser={setDatadogUser} /> : <WebApp setDatadogUser={setDatadogUser}/>}
                </WebRTCProvider>
              </SocketProvider>
            </ErrorBoundary>
          </Suspense>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();

serviceWorkerRegistration.register();